import "./EndPage.css";
import Leaderboard from "./EndGameLeaderboard";
import config from "./appconf";
import ReactCanvasConfetti from "react-canvas-confetti";
import { useCallback, useRef, useEffect, useState } from "react";
import {
  useAppSelector,
  useAppDispatch,
  setHighScores,
  setLowScores,
  setSession,
  setEndGameLeaderboard,
} from "./store";
import { PlayerInfo, SessionInfo } from "./common/Info";
import HistoricalLeaderboard from "./HistoricalLeaderboard";
import { ScoreInfo } from "./common/Info";
import { connectToSSE } from "./EventSource";
import EndGameReasons from "./EndGameReasons";

const canvasStyles = {
  position: "fixed",
  pointerEvents: "none",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
};

function EndPage() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    fetch(`${config.baseUrl}/api/v1/status`, {
      mode: "cors",
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) {
          res.json().then((sessionInfo: SessionInfo) => {
            dispatch(setSession(sessionInfo));
            dispatch(setEndGameLeaderboard(sessionInfo));
            connectToSSE();
          });
        }
      })
      .catch((error) => {
        console.log("Ran into an error trying to get status data");
        console.log(error);
      });
  }, []);

  const refAnimationInstance = useRef(null);

  const players = useAppSelector((state) => {
    return state.players;
  });
  const profile = useAppSelector((state) => {
    return state.profile;
  });
  const game = useAppSelector((state) => {
    return state.game;
  });

  const [historicalModalEnabled, setHistoricalModalEnabled] = useState(false);
  const showHistoricalModal = () => {
    setHistoricalModalEnabled(true);
  };
  const hideHistoricalModal = () => {
    setHistoricalModalEnabled(false);
  };

  const isWinner = (userId: string, players: PlayerInfo[]): boolean => {
    if (!players || players.length === 0) {
      console.log("Cannot calculate winner because players is null or empty");
      return false;
    }
    const playersCopy = players.slice();
    playersCopy.sort((a, b) => b.score - a.score);
    return userId === playersCopy[0].id;
  };

  const getInstance = useCallback((instance: any) => {
    refAnimationInstance.current = instance;
  }, []);

  const makeShot = useCallback((particleRatio: any, opts: any) => {
    refAnimationInstance.current &&
      refAnimationInstance.current({
        ...opts,
        origin: { y: 0.7 },
        particleCount: Math.floor(200 * particleRatio),
      });
  }, []);

  const fire = useCallback(() => {
    makeShot(0.25, {
      spread: 26,
      startVelocity: 55,
    });

    makeShot(0.2, {
      spread: 60,
    });

    makeShot(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 45,
    });
  }, [makeShot]);

  useEffect(() => {
    if (isWinner(profile.id, players)) {
      fire();
    }
  }, []);

  useEffect(() => {
    fetch(`${config.baseUrl}/api/v1/scores?order=descending&limit=5`, {
      method: "GET",
      mode: "cors",
      credentials: "include",
    })
      .then((res) => {
        console.log(`status of high score request ${res.status}`);
        res.json().then((scores: ScoreInfo[]) => {
          dispatch(setHighScores(scores));
        });
      })
      .catch((error) => {
        console.log("failed to fetch high scores");
        console.log(error);
      });
    fetch(`${config.baseUrl}/api/v1/scores?order=ascending&limit=5`, {
      method: "GET",
      mode: "cors",
      credentials: "include",
    })
      .then((res) => {
        console.log(`status of low score request ${res.status}`);
        res.json().then((scores: ScoreInfo[]) => {
          dispatch(setLowScores(scores));
        });
      })
      .catch((error) => {
        console.log("failed to fetch high scores");
        console.log(error);
      });
  }, []);

  const handleQuit = () => {
    fetch(`${config.baseUrl}/api/v1/quit`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
    }).then((res) => {
      console.log(`player quit and got a http response of ${res.status}`);
    });
  };

  return (
    <div className="centerContainer height100">
      <div className="leaderboardContainer">
        <h1>Game Over</h1>
        <EndGameReasons />
        <Leaderboard />
        <HistoricalLeaderboard
          enabled={historicalModalEnabled}
          hideModal={hideHistoricalModal}
        />
        <div className="endButtonBox">
          <button className="primaryButton" onClick={showHistoricalModal}>
            See leaderboard
          </button>
          <button className="actionButton" onClick={handleQuit}>
            Return to Lobby
          </button>
        </div>
      </div>
      <ReactCanvasConfetti refConfetti={getInstance} style={canvasStyles} />
    </div>
  );
}

export default EndPage;
